<template>
  <div class="grid grid-rows-[auto_1fr] h-full overflow-hidden border-t">
    <InputTag
      v-model:prompt="reqData.matePrompt"
      v-model:negative-prompt="reqData.mateNegativePrompt"
      v-model:is-positive="isPositive"
    />
    <!-- 人物特征 -->
    <mate-trait-selection1
      :req-data="reqData"
      enable-selection
      enable-edit
      :selected-trait="selectedTrait"
      @update:selected-trait="clickSelectedTrait"
    />
  </div>
</template>

<script lang="ts" setup>
import { useMateTrait } from "@/stores/mateTrait";
import { ref, PropType, onMounted } from "vue";
import { initStyle } from "./initStyle";
import { useRoute } from "vue-router";

const props = defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
});

const traitStore = useMateTrait();
const route = useRoute();

// 人物特征
const selectedTrait = ref<MateTrait | null>();
// 选择特征
const clickSelectedTrait = (trait: MateTrait | null) => {
  selectedTrait.value = trait;
  if (trait) {
    const { style, mixStyle, customStyle } = trait;
    if (
      ([6, 9].includes(Number(route.query.mode)) &&
        (!customStyle?.version || customStyle.version !== 1)) ||
      ([2, 3, 4].includes(Number(route.query.mode)) &&
        (!customStyle || customStyle.version === 0))
    ) {
      props.reqData.style = undefined;
      props.reqData.mixStyle = [];
      props.reqData.customStyle = {
        version: 1,
        prompt: customStyle?.prompt || "",
      };
    } else initStyle(props.reqData, style, customStyle, mixStyle);
    props.reqData.mateTraitId = trait?.id;
    initMateTrait(trait.id);
  } else {
    props.reqData.mateTraitId = undefined;
    props.reqData.matePrompt = "";
    props.reqData.mateNegativePrompt = "";
  }
};

const isPositive = ref(true);

const initMateTrait = async (id?: number, prompt?: string) => {
  if (!id) return;
  selectedTrait.value = await traitStore.getOrFetchTraitItem(id);
  isPositive.value = true;
  if (!prompt) {
    props.reqData.matePrompt = selectedTrait.value.prompt || "";
    props.reqData.mateNegativePrompt = selectedTrait.value.negativePrompt || "";
  }
};

onMounted(async () => {
  initMateTrait(
    props.reqData.mateTraitId || undefined,
    props.reqData.matePrompt
  );
});
</script>
